import { downloadDraftInvoicePdf, downloadInvoicePdf , downloadSalarySlip } from '../v2/api/chat';
/**
 * Helper function to handle invoice PDF download
 * Handles blob conversion, file creation, and download triggering
 * @param invoiceNumber - The invoice number to download
 * @param locale - The locale for the PDF (default: sv-se)
 * @returns Promise<void>
 */
export const downloadInvoiceAsPdf = async (
  invoiceNumber: string,
  locale: string = 'sv-se'
): Promise<void> => {
  try {
    // Convert to string and validate
    const normalizedInvoiceNumber = String(invoiceNumber).trim();
    
    if (!normalizedInvoiceNumber || normalizedInvoiceNumber.length === 0) {
      throw new Error('Invoice number is required');
    }

    const blob = await downloadInvoicePdf({
      invoiceNumber: normalizedInvoiceNumber,
      locale,
    });

    // Validate that we received a blob
    if (!blob || blob.size === 0) {
      throw new Error('Failed to retrieve invoice PDF');
    }

    // Create a temporary download link
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `Invoice_${normalizedInvoiceNumber}.pdf`;

    // Append to body, trigger click, and cleanup
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Cleanup the object URL
    window.URL.revokeObjectURL(url);
  } catch (error: any) {
    console.error('Invoice download error:', error);
    throw new Error(
      error.message || 'Failed to download invoice. Please try again.'
    );
  }
};

/**
 * Helper function to handle invoice PDF download
 * Handles blob conversion, file creation, and download triggering
 * @param invoiceNumber - The invoice number to download
 * @param locale - The locale for the PDF (default: sv-se)
 * @returns Promise<void>
 */
export const downloadInvoiceDraftAsPdf = async (
  invoiceNumber: string,
  locale: string = 'sv-se'
): Promise<void> => {
  try {
    // Convert to string and validate
    const normalizedInvoiceNumber = String(invoiceNumber).trim();
    
    if (!normalizedInvoiceNumber || normalizedInvoiceNumber.length === 0) {
      throw new Error('Invoice number is required');
    }

    const blob = await downloadDraftInvoicePdf({
      invoiceNumber: normalizedInvoiceNumber,
      locale,
    });

    // Validate that we received a blob
    if (!blob || blob.size === 0) {
      throw new Error('Failed to retrieve invoice PDF');
    }

    // Create a temporary download link
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `Invoice_${normalizedInvoiceNumber}.pdf`;

    // Append to body, trigger click, and cleanup
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Cleanup the object URL
    window.URL.revokeObjectURL(url);
  } catch (error: any) {
    console.error('Invoice download error:', error);
    throw new Error(
      error.message || 'Failed to download invoice. Please try again.'
    );
  }
};


export const downloadSalarySlipAsPdf = async (
  invoiceNumber: number,
  locale: string = 'sv-se',
  type: number
): Promise<void> => {
  try {
    // Convert to string and validate
    const normalizedInvoiceNumber = String(invoiceNumber).trim();
    
    if (!normalizedInvoiceNumber || normalizedInvoiceNumber.length === 0) {
      throw new Error('Invoice number is required');
    }

    const blob = await downloadSalarySlip({
      invoiceNumber: normalizedInvoiceNumber,
      locale,
        
    }, type);

    // Validate that we received a blob
    if (!blob || blob.size === 0) {
      throw new Error('Failed to retrieve salary slip');
    }

    // Create a temporary download link
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `SalarySlip_${normalizedInvoiceNumber}.pdf`;

    // Append to body, trigger click, and cleanup
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Cleanup the object URL
    window.URL.revokeObjectURL(url);
  } catch (error: any) {
    console.error('Invoice download error:', error);
    throw new Error(
      error.message || 'Failed to download invoice. Please try again.'
    );
  }
};